document.addEventListener("DOMContentLoaded", () => {

  const allowedDomains = [
    'vtwonen.nl',
    'dpgmedia.nl',
    'shopify.com',
    'myshopify.com'
  ];

  const socialDomains = [
    'facebook.com',
    'instagram.com',
    'tiktok.com',
    'pinterest.com',
    'youtube.com',
    'youtu.be',
    'x.com',
    'twitter.com',
    'google.com'
  ];

  const links = document.querySelectorAll('a[href]');

  links.forEach(link => {

    const href = link.getAttribute('href');
    if (!href) return;

    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) return;

    const url = new URL(href, window.location.origin);
    const hostname = url.hostname.replace('www.', '');

    const isAllowed = allowedDomains.some(domain =>
      hostname.endsWith(domain)
    );

    const isSocial = socialDomains.some(domain =>
      hostname.includes(domain)
    );

    if (!isAllowed && !isSocial) {

      const isSponsored = link.closest('[data-sponsored-links]');

      const rel = link.getAttribute('rel') || '';
      const relParts = rel.split(' ').filter(Boolean);

      if (!relParts.includes('nofollow')) {
        relParts.push('nofollow');
      }

      if (isSponsored && !relParts.includes('sponsored')) {
        relParts.push('sponsored');
      }

      link.setAttribute('rel', relParts.join(' '));

      if (!link.hasAttribute('target')) {
        link.setAttribute('target', '_blank');
      }

    }

  });

});